export default __webpack_public_path__ + "locales/sk/PaymentsEnterprise.json?hash=f10b33ed92531366690e3765ef6ba402";